export const CHARGE_STATUSES = [
    { id: 'paid', label: 'Paga', variant: 'success' },
    { id: 'pending', label: 'Pendente', variant: 'warning' },
    { id: 'refunded', label: 'Reembolsada', variant: 'info' },
    { id: 'chargeback', label: 'Chargeback', variant: 'danger' },
    { id: 'failed', label: 'Falhou', variant: 'danger' },
    { id: 'canceled', label: 'Cancelada', variant: 'default' },
];

export const CHARGE_STATUS_MAP = CHARGE_STATUSES.reduce((acc, s) => {
    acc[s.id] = s;
    return acc;
}, {});
